<template>
  <!-- MODULE ADMIN SECTION -->
  <v-flex
    class="pa-1"
    xs12
    sm6
    lg4
    xl3
    v-if="
      (($store.state.storeAuth.userProfile.isAdmin ||
        $store.state.storeAuth.userProfile.isSuperAdmin ||
        $store.state.storeAuth.userProfile.isSuperStoreAdmin ||
        ($store.state.storeClient.client.modules.modulePhotoOrder.active &&
          $store.state.storeAuth.userProfile.isAdmin)) &&
        $store.state.storeClient.client.basicSettings.name ==
          $store.state.storeAuth.userProfile.client) || $store.state.storeAuth.userProfile.isSuperStoreAdmin
    "
  >
    <v-card
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="
        getTheme() == 'dark'
          ? 'border: 1px solid darkgray; background-color: whitesmoke;'
          : 'border-bottom: 1px solid lightgray; background-color: white;'
      "
      style="height:100%;"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-3"
          medium
        >mdi-video-input-component</v-icon>
        {{ $t("dashboardCardAdminSectionTitle") }}
      </v-card-title>
      <transition name="fade" key="1" mode="out-in">
        <v-card-text class="ma-0 pa-0" key="1" v-show="visibleIsAdminShowPackages">
          <div
            class="font-weight-regular px-4 py-2 ma-0 white--text warning"
            v-if="
              $store.state.storeClient.client.modules.modulePhotoOrder.active &&
                $store.state.storeAuth.userProfile.isAdmin
            "
          >
            <div class="animated bounceInRight">
              <span
                class="ma-0 pa-0"
                v-if="
                  $store.state.storeAuth.userProfile.isAdminShowPackages
                    .length > 0
                "
              >
                <v-icon color="white" left medium>mdi-eye</v-icon>
                <span
                  v-for="(item, index) in $store.state.storeAuth.userProfile
                    .isAdminShowPackages"
                  :key="item"
                  class="ml-1"
                >
                  <span v-if="index > 0">
                    <v-icon color="white" left small>mdi-circle-small</v-icon>
                  </span>
                  {{ item }}
                </span>
              </span>
              <span v-else>
                <v-icon color="white" left medium>mdi-eye</v-icon>
                {{ $t("dashboardCardAdminActivePackagesViewTitle") }}
              </span>
            </div>
          </div>
        </v-card-text>
      </transition>
      <v-card-actions
        class="d-flex flex-wrap align-stretch"
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke'
            : 'background-color: white' 
        "
      >
        <!-- MODULE PHOTO ORDER / PAKETI -->
        <div
          v-if="
            ($store.state.storeClient.client.modules.modulePhotoOrder.active &&
              $store.state.storeAuth.userProfile.isAdmin && $store.state.storeAuth.userProfile.client ==
                $store.state.storeClient.client.basicSettings.name) || $store.state.storeAuth.userProfile.isSuperStoreAdmin
          "
          class="pa-2 pt-3 text-center"
          style="width: 105px;"
        >
          <div
            :key="
              $store.state.storeOrders.packages.filter((x) => x.status == 0)
                .length
            "
          >
            <div>
              <v-btn
                fab
                outlined
                to="/homeMenuAdminPackages"
                :class="
                  getTheme() == 'dark' ? 'primary--text' : 'primary--text'
                "
              >
                <v-badge
                  v-if="
                    $store.state.storeOrders.packages.filter(
                      (x) => x.status == 0
                    ).length > 0
                  "
                  class="animated bounce"
                  style="animation-delay: 3s"
                  color="error"
                >
                  <template v-slot:badge>
                    {{
                    $store.state.storeOrders.packages.filter(
                    (x) => x.status == 0
                    ).length
                    }}
                  </template>
                  <v-icon>mdi-image-multiple</v-icon>
                </v-badge>
                <div v-else>
                  <v-icon>mdi-image-multiple</v-icon>
                </div>
              </v-btn>
            </div>
          </div>
          <div style="margin-top: 5px;">{{ $t("dashboardCardModulePhotoOrderTitle") }}</div>
        </div>
        <!-- NASTAVITVE APLIKACIJE -->
        <home-menu-admin-btn
          :allow="($store.state.storeAuth.userProfile.isSuperAdmin &&
              $store.state.storeAuth.userProfile.client ==
                $store.state.storeClient.client.basicSettings.name) || $store.state.storeAuth.userProfile.isSuperStoreAdmin"
          path="/settingsSubMenu"
          icon="mdi-shield-home"
          :title="$t('dashboardCardSuperAdminTitle')"
        ></home-menu-admin-btn>
        <!-- STATISTIKA APLIKACIJE -->
        <home-menu-admin-btn
          :allow="($store.state.storeAuth.userProfile.isSuperAdmin &&
              $store.state.storeAuth.userProfile.client ==
                $store.state.storeClient.client.basicSettings.name) || $store.state.storeAuth.userProfile.isSuperStoreAdmin"
          path="/stats"
          icon="mdi-poll"
          :title="$t('dashboardCardSuperAdminAppStatistics')"
        ></home-menu-admin-btn>
        <!-- UPRAVITELJ APLIKACIJE / SUPER SUPER ADMIN-->
        <home-menu-admin-btn
          :allow="$store.state.storeAuth.userProfile.isSuperStoreAdmin"
          path="/settingsClient"
          icon="mdi-account-star"
          :title="$t('dashboardCardAddClientSuperAdminTitle')"
        ></home-menu-admin-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import HomeMenuAdminBtn from "@/components/HomeMenuAdminBtn";

export default {
  name: "home-menu-admin",
  components: {
    HomeMenuAdminBtn
  },
  data() {
    return {
      visibleIsAdminShowPackages: true
    };
  },
  created() {
    setTimeout(() => (this.visibleIsAdminShowPackages = false), 5000);
  }
};
</script>
